import PointsForDiscount from 'components/Content/BeautyInsider/BeautyInsiderModules/PointsForDiscount/PointsForDiscount';
import { withPointsForDiscountProps } from 'viewModel/content/BeautyInsider/BeautyInsiderModules/PointsForDiscount/withPointsForDiscountProps';

export default withPointsForDiscountProps(PointsForDiscount);
